export default {
  __contact_specialist: "ติดต่อผู้เชี่ยวชาญ",
  __last_update: "อัปเดตล่าสุด",
  __last_updated: "อัปเดตล่าสุด: ",
  __menu_header: "เมนู",
  __updated: "เมื่อ",
  __request: "ติดต่อ",
  __daily: "รายวัน",
  __weekly: "รายสัปดาห์",
  __monthly: "รายเดือน",
  __date: "วัน",
  __month: "เดือน",
  __today: "วันนี้",
  __yesterday: "เมื่อวาน",
  __last_7_days: "7 วันที่แล้ว",
  __last_week: "สัปดาห์ที่แล้ว",
  __last_30_days: "30 วันที่แล้ว",
  __last_month: "เดือนที่แล้ว",
  __no_data: "ไม่มีข้อมูล",
  __loading: "กำลังโหลด...",
  __example: "ตัวอย่าง",
  __clicks: "จำนวนคลิก",
  __cost: "ค่าใช้จ่าย",
  __impressions: "การแสดงผล",
  __ctr: "CTR",
  __cpc: "CPC",
  __avg_cpc: "ค่าเฉลี่ย CPC",
  __conversion: "Conversion",
  __campaigns: "แคมเปญ",
  __keywords: "คีย์เวิร์ด",
  __audiences: "กลุ่มเป้าหมาย",
  __days: "วัน",
  __metrics: "ตัวชี้วัด",
  __amount: "จำนวน",
  __display: "แสดง: ",
  __apply: "ตกลง",
  __cancel: "ยกเลิก",
  __save: "บันทึก",
  __confirm: "ยืนยัน",
  __date_on: "ข้อมูลเมื่อ",
  __total_column: "<0>{{count}}ทั้งหมด</0>",
  __toast_warning_limit_alternate_column:
    "สามารถเลือกได้ครั้งละ {{count}} เมทริกซ์ กรุณาเลือกเมทริกซ์เดิมออกก่อนเพื่อเพิ่มใหม่",
  __selected_metrics: "ตัวชี้วัดที่เลือก",
  __available_metrics: "ตัวชี้วัดที่สามารถใช้ได้",
  __open_contact: "ติดต่อสอบถาม โทร 02-016-6789",
  __settings_menu: "ตั้งค่า",
  __my_drive: "ไดรฟ์ของฉัน",
  __shared_drive: "ไดรฟ์ที่แชร์",
  __shared_with_me: "แชร์กับฉัน",
  __disconnected: "ยกเลิกการเชื่อมต่อ",
  __gate_label: "เลือกทางเข้า",
  __add_connection: "เพิ่มการเชื่อมต่อ",
  __delete: "ลบ",
  __edit: "แก้ไข",
  __connection_problem: "การเชื่อมต่อมีปัญหา",
  __edit_time: "แก้ไขเมื่อ",
  __by: "โดย",
  __all: "ทั้งหมด",
  __custom: "กำหนดเอง",
  __deleted: "ถูกลบ",
  __file_name: "ชื่อไฟล์",
  __file_position: "ตำแหน่ง",
  __file_updated_date: "แก้ไขเมื่อ",
  __file_updated_by: "แก้ไขโดย",
  __save_success: "บันทึกสำเร็จ",
  __save_failed: "บันทึกไม่สำเร็จ",
  __confirm_delete: "ยืนยันลบการเชื่อมต่อนี้",
  __delete_success: "ลบการเชื่อมต่อเรียบร้อยแล้ว",
  __delete_failed: "ลบการเชื่อมต่อไม่สำเร็จ",
  __show_more: "แสดงเพิ่มเติม",
  __used: "ถูกใช้ในการเชื่อมต่ออื่น",
  __select_form_warning: "กรุณาเลือกอย่างน้อย 1 ฟอร์ม",
  __sheets_input_warning: "กรุณากรอก URL ให้ถูกต้อง",
  __browse: "Browse",
  __selected_form_warning: "ฟอร์มที่คุณเลือกถูกใช้ในการเชื่อมต่ออื่น",
  __fb_error_permission_denied: "คุณไม่มีสิทธิ์เข้าถึงเพจ Facebook นี้",
  __fb_error_token_expire: "การเชื่อมต่อหมดอายุ",
  __google_error_file_permission_denied: "คุณไม่มีสิทธิ์เข้าถึงไฟล์นี้",
  __google_error_token_expire: "การเชื่อมต่อหมดอายุ",
  __google_error_gsheet_not_found: "ไม่พบไฟล์นี้",
  __google_error_403_insert_fail: "คุณไม่มีสิทธิ์แก้ไขไฟล์นี้",
  __rcrm_error_gate_lost: "ไม่พบข้อมูลทางเข้านี้ใน R-CRM",
  __lead_step: "ขั้นตอนของ Lead",
  __form_id: "ID แบบฟอร์ม",
  __file_info_error: "ไม่พบไฟล์ หรือการเชื่อมต่อมีปัญหา กรุณาแก้ไขการเชื่อมต่อ",
  __connection_try_again: "กรุณาลงชื่อเข้าใช้ใหม่อีกครั้ง",

  //Dashboard
  __dashboard: "ภาพรวม",
  __dashboard_spending: "ค่าใช้จ่าย",
  __dashboard_conversion: "Conversions",
  __dashboard_top_keyword: "คีย์เวิร์ด:",
  __dashboard_top_campaign: "แคมเปญ:",
  __dashboard_top_click: "จำนวนคลิก:",
  __top_5_keywords: "คีย์เวิร์ดที่มี Click สูงสุด 5 รายการ",
  __see_all_keywords: "ดูข้อมูลคีย์เวิร์ดทั้งหมด",
  __remaining_budget: "ยอดเงินคงเหลือ",
  __avg_daily_spend: "ค่าใช้จ่ายเฉลี่ยรายวัน",
  __estimated_exhaust: "สามารถโฆษณาได้อีก",

  //Contact
  __contact_title: "ติดต่อ",
  __contact_tel: "เบอร์โทร: ",
  __contact_email: "อีเมล: ",
  __contact_click_to_call: "โทรออก",
  __contact_click_email: "ส่งอีเมล",

  //Suggestion
  __adpro_suggestion: "คำแนะนำจาก R-Ads",
  __average_cpa: "ค่าเฉลี่ย CPA",
  __suggestion_campaing: "แคมเปญ:",
  __suggestion_click: "จำนวนคลิก",
  __suggestion_conversion: "Conversion",
  __cpa_is_above_avg: "ค่า CPA เกินค่าเฉลี่ย",
  __daily_budget: "ค่าใช้จ่ายรายวัน:",
  __suggestion_keyword: "คีย์เวิร์ด:",
  __low_performance_keyword: "คีย์เวิร์ดที่ต้องปรับปรุง",
  __no_tracking_data: "ไม่มีข้อมูล",
  __no_tracking_data_desc:
    "กรุณาติดต่อผู้เชี่ยวชาญของท่าน เพื่อติดตั้ง R-Widget สำหรับเก็บรวบรวมข้อมูลบนเว็บไซต์ของท่าน",
  __opportunity: "โอกาสทางธุรกิจ",
  __raise_daily_budget: "เพิ่มงบโฆษณารายวันอีก",
  __spending: "ค่าใช้จ่าย",
  __suggestion: "คำแนะนำ",

  //payment
  __payment: "การชำระเงิน",
  __payment_history: "ประวัติการชำระเงิน",
  __recent_items: "รายการล่าสุด",
  __days_to_exhust: "<0>สามารถโฆษณาได้อีก {{count}} วัน</0>",
  __estimate_on_current_budget: "คำนวณจากยอดเงินคงเหลือ",

  //Account Performance
  __account_performance: "ประสิทธิภาพโฆษณา",
  __comparison: "เปรียบเทียบ",
  __comparison_period: "เลือกช่วงเวลาที่ต้องการตรวจสอบ",
  __trending: "แนวโน้ม",

  // RMP Conversions
  __rmp_conversions: "Offline Conversions",

  //campaigns
  __search_campaign: "แคมเปญการค้นหา",
  __display_campaign: "แคมเปญการแสดงผล",
  __top_20_keywords: "คีย์เวิร์ด 20 อันดับแรก",
  __top_20_audiences: "กลุ่มเป้าหมาย 20 อันดับแรก",
  __top_20_placements: "Placements 20 อันดับแรก",
  __campaign: "แคมเปญ",

  //Wizard
  __setup_ads: "ตั้งค่าบัญชีโฆษณา",
  __google_ads: "บัญชี Google Ads",
  __facebook_ads: "บัญชีโฆษณา Meta",
  __business_name: "ชื่อธุรกิจ",

  //Settings
  __ads_account: "บัญชีโฆษณา",
  __back_to_dashboard: "กลับไปหน้าภาพรวม",
  __change_ads_error: "เกิดข้อผิดพลาดในการเปลี่ยนบัญชีโฆษณา กรุณาลองใหม่อีกครั้งในภายหลัง",

  // Google Ads
  __ads_label_google_ads_account: "บัญชี Google Ads",
  __ads_setup_description:
    "เชื่อมโยงบัญชี Google Ads ของคุณกับ Readyplanet (Google Partner) เพื่อให้ระบบสามารถเก็บข้อมูลทางสถิติ พร้อมทั้งส่งรายงานวิเคราะห์ข้อมูลที่เป็นประโยชน์ เพื่อให้การทำโฆษณาเป็นไปอย่างมีประสิทธิภาพมากยิ่งขึ้น",
  __ads_setup_learn_more: "เรียนรู้เพิ่มเติมเกี่ยวกับ",
  __ads_setup_learn_more_link: "บัญชีดูแลจัดการ Google Ads",
  __ads_setup_manual_link: "เรียนรู้เพิ่มเติม",
  __ads_setup_policy_link: "เงื่อนไขการใช้บริการ",
  __ads_setup_privacy_link: "นโยบายความเป็นส่วนตัว",
  __ads_setup_filter_placeholder: "ค้นหาจากชื่อหรือหมายเลขบัญชี Google Ads",
  __ads_setup_title: "บัญชีโฆษณา",
  __ads_setup_subtitle: "กรอกบัญชี Google Ads ของคุณที่ต้องการเชื่อมต่อกับ Readyplanet (Google Partner)",
  __ads_setup_selection_subtitle: "เลือกบัญชี Google Ads ของคุณที่ต้องการเชื่อมต่อกับ Readyplanet (Google Partner)",
  __ads_setup_use_other_account: "ใช้บัญชี Google อื่น",
  __ads_setup_or: "หรือ",
  __ads_setup_save: "บันทึก",
  __ads_setup_save_success: "บันทึกสำเร็จ",
  __ads_setup_save_failed: "ไม่สามารถเชื่อมต่อบัญชี Google Ads ได้",
  __ads_setup_validate_params_failed: "กรุณาเลือกหรือ ระบุ บัญชี Google Ads",
  __ads_setup_no_available_ads: "บัญชีนี้ยังไม่มีบัญชี Google Ads",
  __ads_connected_account_name: "บัญชี",
  __ads_connected_account_status: "สถานะ",
  __ads_connected_account_connected: "เชื่อมต่อแล้ว",
  __ads_connected_account_not_connected: "การเชื่อมต่อมีปัญหา",
  __ads_connected_account_edit: "แก้ไข",
  __ads_offline_conversion_title: "Offline Conversions",
  __ads_offline_conversion_sync: "ส่งข้อมูลจาก R-Ads ไปยัง Google",
  __ads_offline_conversion_active: "เปิดใช้งาน",
  __ads_offline_conversion_save_success: "บันทึกสำเร็จ",
  __ads_offline_conversion_save_failed: "บันทึกไม่สำเร็จ",
  __ads_offline_conversion_active_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง Offline Conversions",
  __ads_offline_conversion_inactive_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง Offline Conversions",
  __ads_offline_conversion_confirm_button: "ยืนยัน",
  __ads_offline_conversion_cancel_button: "ยกเลิก",
  __ads_widget_description:
    "ข้อมูลสถิติการใช้งาน และพฤติกรรมของผู้เข้าชมเว็บไซต์จะถูกรวบรวมส่งเป็นข้อมูล Offline Conversions กลับไปยังบัญชีโฆษณา Google Ads เพื่อให้ผู้ลงโฆษณาสามารถนำข้อมูลไปต่อยอดในการทำ Smart Bidding ต่อไปได้",
  __ads_widget_action: "Action",
  __ads_widget_conversion_name: "ชื่อ Conversion",
  __ads_widget_action_form: "การกรอก แบบฟอร์ม",
  __ads_widget_action_call: "การคลิก โทร",
  __ads_widget_action_line: "การคลิก LINE",
  __ads_widget_action_facebook: "การคลิก Facebook",
  __ads_widget_action_others: "อื่นๆ",
  __ads_widget_action_behavior: "พฤติกรรมของผู้เข้าชมเว็บไซต์",
  __ads_widget_action_last_update: "อัปเดตล่าสุด",
  __ads_widget_action_callback_form: "ฝากเบอร์ติดต่อกลับ",
  __ads_widget_action_google_maps: "แผนที่",
  __ads_widget_action_zalo: "Zalo",
  __ads_widget_action_skype: "Skype",
  __ads_widget_action_whatsapp: "Whatsapp",
  __ads_widget_action_rchat: "R-Chat",
  __ads_widget_action_custom_button: "ปุ่มกำหนดเอง",
  __ads_widget_action_total_action: "ทุกๆการคลิกช่องทางการติดต่อ",
  __ads_crm_description:
    "ข้อมูลการใช้งานจะถูกส่งไปยังบัญชี Google Ads โดยสามารถเลือก Lead Pipeline ที่ต้องการและเลือกการส่งข้อมูลได้",
  __ads_crm_conversion_active_confirm: "ยืนยันการเปลี่ยนแปลงการส่งข้อมูลไปยัง Google Ads",
  __ads_crm_conversion_inactive_confirm: "ยืนยันการเปลี่ยนแปลงการส่งข้อมูลไปยัง Google Ads",
  __ads_crm_conversion_confirm_button: "ยืนยัน",
  __ads_crm_conversion_cancel_button: "ยกเลิก",
  __ads_crm_conversion_sync: "ส่งข้อมูลไปยังบัญชี Google Ads",
  __ads_crm_conversion_send_data: "ส่งข้อมูล",
  __ads_crm_conversion_unsend_data: "ไม่ส่งข้อมูล",
  __ads_crm_conversion_name: "ชื่อ Conversion",
  __ads_crm_conversion_save_success: "บันทึกสำเร็จ",
  __ads_crm_conversion_save_failed: "บันทึกไม่สำเร็จ",
  __ads_crm_conversion_last_update: "อัปเดตล่าสุด",
  __ads_conversion_no_data: "ไม่มีข้อมูล",
  __ads_crm_lead_pipeline: "Lead Pipeline",
  __ads_crm_lead_step: "ขั้นตอนของ Lead",
  __ads_crm_following_lead: "Lead ที่อยู่ระหว่างติดตาม",
  __ads_crm_unfollowed_lead: "Lead ที่เลิกติดตาม",
  __ads_performance_all_option: "ทั้งหมด",
  __ads_crm_lead_conversion_value: "มูลค่า",

  __ads_initial_value: "มูลค่าเริ่มต้น",
  __ads_conversion_set_button: "สร้าง Custom Conversion",
  __ads_conversion_set_table_header_set_name: "ชื่อ",
  __ads_conversion_set_table_header_lead_source: "แหล่งที่มาของ Lead",
  __ads_modal_conversion_set_title_add: "สร้าง Custom Conversion",
  __ads_modal_conversion_set_title_edit: "แก้ไข Custom Conversion",
  __ads_modal_conversion_set_title_view: "Custom Conversion",
  __ads_modal_delete_conversion_set_message: "ท่านต้องการลบกลุ่ม Conversion นี้ใช่หรือไม่?",
  __ads_title_standard_conversion: "Conversion ตามขั้นตอนและสถานะของ Lead",
  __ads_titlle_conversion_set: "ตั้งค่าการจัดการกลุ่ม Conversion ตามแหล่งที่มาของ Lead",
  __ads_tooltip_conversion_set: "ส่งข้อมูล Conversion ไปยังบัญชี Google Ads เมื่อ Lead มีแหล่งที่มาตามที่ระบุไว้",
  __ads_google_sheets_description: "ข้อมูลการใช้งานจะถูกส่งไปยังบัญชี Google Ads",
  __ads_google_sheets_conversion_sync: "ส่งข้อมูลไปยังบัญชี Google Ads",
  __ads_google_sheets_conversion_send_data: "ส่งข้อมูล",
  __ads_google_sheets_conversion_unsend_data: "ไม่ส่งข้อมูล",
  __ads_google_sheets_conversion_name: "ชื่อ Conversion",

  // Facebook Ads
  __fbads_facebook_setting_edit_on_rdynamic: "สามารถตั้งค่าบัญชี Facebook ได้ที่ R-Dynamic หากต้องการตั้งค่า",
  __fbads_facebook_setting_edit_on_rdynamic_click_here: "คลิกที่นี่",
  __fbads_facebook_setting_error_occurred: "มีบางอย่างผิดพลาด โปรดลองใหม่ภายหลัง",
  __fbads_facebook_setting_validate_failed: "โปรดตรวจสอบข้อมูล",
  __fbads_conversion_sync: "ส่งข้อมูลจาก R-Ads ไปยัง Meta",
  __fbads_widget_description:
    "ข้อมูลสถิติการใช้งาน และพฤติกรรมของผู้เข้าชมเว็บไซต์จะถูกรวบรวมส่งเป็นข้อมูล Web Conversions กลับไปยังบัญชีโฆษณา Meta เพื่อให้ผู้ลงโฆษณาสามารถนำข้อมูลไปต่อยอดในการทำ Smart Bidding ต่อไปได้",
  __fbads_rcrm_conversion_sync: "ส่งข้อมูลไปยังบัญชีโฆษณา Meta",
  __fbads_conversion_active_confirm: "ยืนยันการเปลี่ยนแปลงการส่งข้อมูลไปยังบัญชีโฆษณา Meta",
  __fbads_conversion_inactive_confirm: "ยืนยันการเปลี่ยนแปลงการส่งข้อมูลไปยังบัญชีโฆษณา Meta",
  __fbads_crm_description:
    "ข้อมูลการใช้งานจะถูกส่งไปยังบัญชีโฆษณา Meta โดยสามารถเลือก Lead Pipeline ที่ต้องการและเลือกการส่งข้อมูลได้",
  __fbads_setup_title: "บัญชีโฆษณา",
  __fbads_setup_setting_button: "ตั้งค่า",
  __fbads_setup_sub_title: "เชื่อมต่อ R-Ads กับบัญชี Facebook ของคุณ",
  __fbads_setup_save_success: "บันทึกสำเร็จ",
  __fbads_setup_save_failed: "ไม่สามารถเชื่อมต่อบัญชี Facebook ได้",
  __fbads_setup_account_business: "บัญชีธุรกิจ",
  __fbads_setup_account_ads: "บัญชีโฆษณา",
  __fbads_setup_account_pixel: "Pixel ID",
  __fbads_setup_error_no_business: "กรุณาเลือกบัญชีธุรกิจ",
  __fbads_setup_error_no_ads_account: "กรุณาเลือกบัญชีโฆษณา",
  __fbads_setup_error_access_ads_account: "ผู้ใช้ Facebook นี้ ไม่สามารถเข้าถึงบัญชีโฆษณานี้ได้",
  __fbads_setup_error_no_pixel: "กรุณากรอก Pixel ID",
  __fbads_setup_error_access_pixel: "ไม่สามารถเข้าถึง Pixel ID นี้ได้",
  __fbads_setup_error_connected_pixel_ads: "Pixel ID ไม่ได้เชื่อมต่อกับบัญชีโฆษณา",
  __fbads_setup_change_account_button: "เปลี่ยนบัญชี Facebook",
  __fbads_setup_save_button: "บันทึก",
  __fbads_setup_more_details: "รายละเอียดเพิ่มเติม",
  __fbads_setup_facebook_login_button: "ดำเนินการต่อด้วย Facebook",
  __fbads_connected_account_business: "บัญชีธุรกิจ",
  __fbads_connected_account_ads: "บัญชีโฆษณา",
  __fbads_connected_account_pixel: "Pixel ID",
  __fbads_connected_account_status: "สถานะ",
  __fbads_connected_account_connected: "เชื่อมต่อแล้ว",
  __fbads_connected_account_not_connected: "การเชื่อมต่อมีปัญหา",
  __fbads_connected_account_error_ads_failed: "ไม่สามารถเข้าถึงบัญชีโฆษณานี้ได้",
  __fbads_connected_account_error_pixel_failed: "ไม่สามารถเข้าถึง Pixel ID นี้ได้",
  __fbads_connected_account_error_pixel_connected_ads_failed: "Pixel ID ไม่ได้เชื่อมต่อกับบัญชีโฆษณา",
  __fbads_connected_account_edit: "แก้ไข",
  __fbads_dashboard_lead_pipeline: "Lead Pipeline",
  __fbads_dashboard_lead_conversion_name: "ชื่อ Conversion",
  __fbads_dashboard_lead_conversion_total: "จำนวน",
  __fbads_dashboard_lead_conversion_value: "มูลค่า",
  __fbads_google_sheets_description: "ข้อมูลการใช้งานจะถูกส่งไปยังบัญชีโฆษณา Meta",
  __fbads_ads_account_not_found: "ไม่พบผลลัพธ์ที่ตรงกับคำค้นหา หรือรหัสบัญชีโฆษณาไม่ถูกต้อง",
  __fbads_ads_account_search_hint: "หากไม่พบบัญชีโฆษณาที่ต้องการ กรุณาพิมพ์ชื่อบัญชี หรือรหัสบัญชีโฆษณา ในช่องค้นหา",
  __fbads_web_conversion_title: "Web Conversions",
  __fbads_web_conversion_active_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง Web Conversions",
  __fbads_web_conversion_inactive_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง Web Conversions",
  __fbads_web_conversion_description:
    "ใช้กับวัตถุประสงค์แคมเปญที่มีกิจกรรม Conversion เกิดขึ้นบนเว็บไซต์ เช่น Leads Conversions, Sales Conversions",
  __fbads_crm_conversion_title: "CRM Conversions",
  __fbads_crm_conversion_active_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง CRM Conversions",
  __fbads_crm_conversion_inactive_confirm: "ยืนยันการเปลี่ยนแปลงการส่ง CRM Conversions",
  __fbads_crm_conversion_connection_crm_warning: "Pixel ID ของคุณไม่ได้เชื่อมต่อกับ CRM",
  __fbads_crm_conversion_description: "ใช้กับวัตถุประสงค์แคมเปญ Instant Lead Forms เท่านั้น",
  __fbads_conversion_no_data: "ไม่มีข้อมูล",

  // Facebook Leads
  __fbleads_title: "Leads",
  __fbleads_title_description: "ตั้งค่าการดึงข้อมูลจาก Facebook Leads และส่งไปยังปลายทางที่เชื่อมต่อ",
  __fbleads_google_sheets_tab_setting_modal: "ตั้งค่าการเชื่อมต่อ",
  __fbleads_change_status_to_active: "ยืนยันเปิดการใช้งาน",
  __fbleads_change_status_to_inactive: "ยืนยันปิดการใช้งาน",
  __fbleads_fb_account: "บัญชี Facebook",
  __fbleads_fb_page: "เพจ Facebook",
  __fbleads_fb_form: "เลือกฟอร์ม",
  __fbleads_google_account: "บัญชี Google",
  __fbleads_google_sheets_url: "Google Sheets",
  __fbleads_google_sheets_file_detail: "รายละเอียดเอกสาร",
  __fbleads_edit_connection: "แก้ไขการเชื่อมต่อ",
  __fbleads_fb_connect: "เชื่อมต่อ Facebook Page",
  __fbleads_google_connect: "เชื่อมต่อ Google Sheets",
  __fbleads_fb_all_forn_describe: "รวมฟอร์มที่เพิ่มในภายหลังด้วย",
  __fbleads_google_error_search_file: "ไม่พบไฟล์ หรือคุณอาจไม่มีสิทธิ์เข้าถึงไฟล์นี้",
  __fbleads_google_error_search_file_type: "รองรับเฉพาะ Google Sheets เท่านั้น",
  __fbleads_fb_page_not_found: "ไม่พบเพจ",
  __fbleads_fb_form_not_found: "ไม่พบฟอร์ม",
  __fbleads_fb_form_used_all_form: "ฟอร์มทั้งหมดถูกใช้ในการเชื่อมต่ออื่น",
  __fbleads_fb_error_login: "เกิดข้อผิดพลาดในการเชื่อมต่อ Facebook Page กรุณาลองใหม่อีกครั้ง",

  // Google Leads
  __googleleads_title: "Leads",
  __googleleads_title_description: "ตั้งค่าการดึงข้อมูลจาก Google Leads และส่งไปยังปลายทางที่เชื่อมต่อ",
  __googleleads_google_ads_account: "บัญชี Google Ads",
  __googleleads_choose_form: "เลือกฟอร์ม",
  __googleleads_google_form_not_found: "ไม่พบฟอร์ม",
  __googleleads_google_form_used_all_form: "ฟอร์มทั้งหมดถูกใช้ในการเชื่อมต่ออื่น",
  __googleleads_google_error_search_file: "ไม่พบไฟล์ หรือคุณอาจไม่มีสิทธิ์เข้าถึงไฟล์นี้",
  __googleleads_google_error_search_file_type: "รองรับเฉพาะ Google Sheets เท่านั้น",
  __googleleads_google_error_change_ads_account: "บัญชี Google Ads นี้ไม่ได้ถูกเชื่อมต่อ",

  // Button Action
  __btn_action_edit: "แก้ไข",
  __btn_action_delete: "ลบ",
  __btn_action_view: "ดูข้อมูล",
  __select_lead_source_placeholder: "ระบุแหล่งที่มา",

  // No Connected Ads
  __noads_description: "ยังไม่ได้ทำการตั้งค่าบัญชีโฆษณา",
  __noads_setting_button: "ตั้งค่า",

  // Error Message
  __ads_crm_conversion_conversion_set_duplicate: "ชื่อ Custom Conversion ซ้ำกับที่มีอยู่แล้ว",
  __ads_crm_conversion_conversion_value_not_valid: "กรุณากรอกตัวเลข",
  __ads_crm_conversion_conversion_set_not_specified: "ระบุข้อมูลไม่ครบถ้วน",
  __ads_facebook_setting_error: "การเชื่อมต่อมีปัญหา กรุณาตรวจสอบการตั้งค่า",

  // Facebook Conversion Stats
  __conversion_header: "Conversions",
  __fb_conversions_r_widget: "R-Widget",
  __fb_conversions_r_crm: "R-CRM",
  __fb_conversions_google_sheets: "Google Sheets",
  __r_widget_conversions: "R-Widget",
  __r_crm_conversions: "R-CRM",
  __google_sheets_conversions: "Google Sheets",
};
